import { GoalFilterDocument, OrderDirection } from '@griply/types';
import { getGoalsOverviewOrder, GoalsOverviewOrder } from '@griply/utils';
import { useGoals } from 'features/goals';
import { useSortedLocalizedLifeAreas } from 'features/life-areas';
import { useMemo } from 'react';
import { useTaskCounts } from 'shared/contexts/task-counts/use-task-counts';
import { useEntityLinks } from 'shared/hooks/use-entity-links';
import { useUser } from 'shared/hooks/use-user';

// The surface's own filter document, not the legacy settings `useSortedGoals` reads: grouping picks the order store.
export const useGoalsOverviewOrder = (
  filterDocument: GoalFilterDocument,
): GoalsOverviewOrder => {
  const user = useUser();
  const goals = useGoals();
  const sortedLifeAreas = useSortedLocalizedLifeAreas();
  const taskCounts = useTaskCounts();
  const links = useEntityLinks();
  const sortDirection = user?.settings?.goalSortDirection ?? OrderDirection.Asc;
  const goalRoadmapSorting = user?.settings?.goalRoadmapSorting;
  const goalGroupSorting = user?.settings?.goalGroupSorting;

  return useMemo(
    () =>
      getGoalsOverviewOrder({
        goals,
        sortedLifeAreas,
        links,
        groupBy: filterDocument.groupByMode ?? undefined,
        sortMode: filterDocument.sortingMode ?? undefined,
        sortDirection,
        goalRoadmapSorting,
        goalGroupSorting,
        taskCounts: taskCounts?.byGoalId,
        goalProgressCounts: taskCounts?.byGoalProgress,
      }),
    [
      goals,
      links,
      sortedLifeAreas,
      filterDocument.groupByMode,
      filterDocument.sortingMode,
      sortDirection,
      goalRoadmapSorting,
      goalGroupSorting,
      taskCounts?.byGoalId,
      taskCounts?.byGoalProgress,
    ],
  );
};
